import React, { useState, useEffect } from "react";
import SocialMediaAnalysisDesktop from "./SocialMediaAnalysisDesktop";
import SocialMediaAnalysisMobile from "./SocialMediaAnalysisMobile";
import ReadOnlyBanner from "../../common/ReadOnlyBanner";
import "../../css/Common.css";

const SocialMediaAnalysis = () => {
  // Mobile detection
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    checkMobile();
    window.addEventListener("resize", checkMobile);

    return () => {
      window.removeEventListener("resize", checkMobile);
    };
  }, []);

  return (
    <div className="social-media-scams">
      <ReadOnlyBanner />
      {isMobile ? (
        <SocialMediaAnalysisMobile />
      ) : (
        <SocialMediaAnalysisDesktop />
      )}
    </div>
  );
};

export default SocialMediaAnalysis;
